import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './allhomes-listing-section.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingSection = _ref => {
  var title = _ref.title,
    children = _ref.children,
    className = _ref.className;
  return ___EmotionJSX("div", {
    css: styles.section,
    className: className
  }, ___EmotionJSX(Heading, {
    css: styles.heading,
    title: title
  }), ___EmotionJSX("div", {
    css: styles.body
  }, children));
};
AllhomesListingSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};
AllhomesListingSection.defaultProps = {
  className: undefined
};
export default AllhomesListingSection;